module.exports = __webpack_public_path__ + "img/Website_banner.3711b568.webp";